import { ButtonHTMLAttributes } from "react";
import styled from "styled-components";
import ArrowRightPink from '../../../../asset/mama/arrow-right-pink.png';
import ArrowRightYellow from '../../../../asset/mama/arrow-right-yellow.png';
import { SIZE_TYPE } from "../../../../common/button/constant";
import { TextElem } from "../../../../common/text";
import { FONT_FAMILY_ENUM } from "../../../../common/text/constant";
import { SIZE_FONT_ENUM } from "../../../../theme/size";

type ColorType = 'yellow' | 'pink' | 'orange';

const COLOR_MAP = {
  yellow: {
    background: 'linear-gradient(180deg, #FFCD00 48.89%, #F2740C 100%)',
    shadow: '#BB5400',
    text: 'black',
    arrow: ArrowRightPink,
  },
  pink: {
    background: 'linear-gradient(90deg, #ff0480 0%, #d7085b 100%)',
    shadow: '#A40049',
    text: 'white',
    arrow: ArrowRightYellow,
  },
  orange: {
    background: 'linear-gradient(0deg, #FF5100 30.5%, #FFA67D 100%)',
    shadow: '#cf4302',
    text: 'black',
    arrow: ArrowRightYellow,
  }
} as const;

type Props = {
  color: ColorType;
  tid: string;
  size?: SIZE_TYPE;
};

const SIZE_MAP = {
  small: {
    height: 27.08,
    size: SIZE_FONT_ENUM.VERY_SMALL,
    shadow: 3,
    icon: 18.95,
  },
  default: {
    height: 47.08,
    size: SIZE_FONT_ENUM.SMALL,
    shadow: 5,
    icon: 28.95
  },
  large: {
    height: 77.08,
    size: SIZE_FONT_ENUM.MEDIUM,
    shadow: 7,
    icon: 38.95
  },
}

export const Component: React.FC<Props & ButtonHTMLAttributes<HTMLButtonElement>> = ({ color, tid, size = 'default', ...props }) => {
  const theme = COLOR_MAP[color];
  const { disabled } = props;

  return (
    <PromoButton $color={color} $size={size} {...props}>
      <TextElem
        tid={tid}
        fontFamily={FONT_FAMILY_ENUM.DELA_GOTHIC_ONE}
        color={theme.text}
        size={SIZE_MAP[size].size}
      />

      {/* <span className="glow" /> */}

      <img
        style={{ "marginLeft": 10 }}
        className="image"
        src={theme.arrow}
        alt="ARROW"
      />
    </PromoButton>
  );
};

export const PromoButton = styled.button<{ $color: ColorType, $size: SIZE_TYPE, disabled?: boolean }>`
  position: relative;
  /* width: 172px; */
  height: ${({ $size }) => SIZE_MAP[$size].height}px;
  border: none;
  border-radius: 689.189px;
  cursor: pointer;
  overflow: hidden;
  text-transform: uppercase;

  background: ${({ $color }) => COLOR_MAP[$color].background};
  box-shadow: 0px ${({ $size }) => SIZE_MAP[$size].shadow}px ${({ $color }) => COLOR_MAP[$color].shadow};

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${({ $size }) => SIZE_MAP[$size].icon}px;
  cursor: pointer;

  @media screen and (max-width: 500px) {
    padding: 10 14px;
    > span:first-child {
    ${({ $size }) =>
    $size === 'large' && 'font-size: 16px;'}
  }
}

  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  :hover {
    opacity: 0.9;
  }

  .glow {
    position: absolute;
    width: 39.4px;
    height: 129.09px;
    left: 55%;
    top: -44.19px;

    background: radial-gradient(
      50% 50% at 50% 50%,
      #ffffff 0%,
      rgba(255, 255, 255, 0) 100%
    );

    opacity: 0.9;
    transform: rotate(27.48deg);
    pointer-events: none;
  }

  .image {
    position: relative;
    z-index: 2;
    height: ${({ $size }) => SIZE_MAP[$size].icon}px;
    object-fit: contain;
  }
`;